import { ErrorHandler, ErrorType } from '@/components/error-handler';
import { BagScanError } from './context';
import { useBagScanContext } from './hook';

const getErrorConfig = (error: BagScanError): ErrorType | null => {
	switch (error) {
		case 'INVALID_BAG_STATE':
			return {
				type: 'warning',
				style: 'minimal',
				title: 'Invalid Bag',
				details: 'This bag is not in a valid state for scanning. Please try a different bag.',
				duration: 5000,
				offset: 176,
			};

		case 'BAG_NOT_FOUND':
			return {
				type: 'warning',
				style: 'minimal',
				title: 'Bag Not Found',
				details: 'The scanned code was not found in the system.',
				duration: 4000,
				offset: 176,
			};

		case 'DUPLICATE_SCAN':
			return {
				type: 'warning',
				style: 'minimal',
				title: 'Already Scanned',
				details: 'This bag has already been scanned in this session.',
				duration: 4000,
				offset: 176,
			};

		case 'BAG_ALREADY_PROCESSED':
			return {
				type: 'warning',
				style: 'minimal',
				title: 'Already Processed',
				details: 'This bag has already been processed and cannot be scanned again.',
				duration: 5000,
				offset: 176,
			};

		case 'NETWORK_ERROR':
			return {
				type: 'error',
				style: 'full',
				title: 'Connection Error',
				details:
					'Unable to connect to the server. Please check your internet connection and try again.',
			};

		case 'SUBMISSION_FAILED':
			return {
				type: 'error',
				style: 'full',
				title: 'Submission Failed',
				details: 'Failed to submit the bag scan. Please try again.',
			};

		case 'UNAUTHORIZED':
			return {
				type: 'error',
				style: 'full',
				title: 'Access Denied',
				details: 'You are not authorized to scan bags at this facility.',
			};

		default:
			return null;
	}
};

/**
 * Error handler specifically for the bag scan workflow.
 * Maps workflow-specific errors to user-friendly messages and displays them using the ErrorHandler component.
 */
export const BagScanErrorHandler = () => {
	const { error, setError } = useBagScanContext();

	// Map workflow errors to ErrorHandler format

	const errorConfig = error ? getErrorConfig(error) : null;

	return <ErrorHandler error={errorConfig} setError={() => setError(null)} />;
};
